import Formie from '@/components/Formie';
import JobPositions from '@/components/JobPositions';
import PageHeader from '@/components/PageHeader';
import Sidebar from '@/components/Sidebar';
import { BoxProps } from '@/components/ui/Box';
import { Entry, isEntry } from '@/lib/parsers/entries';
import LayoutGrid from '../Layout/LayoutGrid';
import BlockHeader from '@/components/BlockHeader';
import { rawColorValues } from '@/theme/partials/palette.css';
import type { ReactNode } from 'react';

export type GridLayoutProps = BoxProps<
  'div',
  {
    entry: Entry<'careers'> | Entry<'contact'>;
    nav: ReactNode;
    footer: ReactNode;
  }
>;

const GridLayout = ({ entry, nav, footer, colorTheme = 'default', ...props }: GridLayoutProps) => {
  const isCareers = isEntry(entry, 'careers');
  const isContact = isEntry(entry, 'contact');

  return (
    <LayoutGrid
      {...{ entry, colorTheme, ...props }}
      slots={{
        nav,
        header: <PageHeader entry={entry} />,
        sidebar: (
          <Sidebar
            {...{
              content: entry.content,
              colorSet: isContact ? 'accentLight' : 'full',
              paper: true,
              cx: isContact ? { pY: 'xl', pX: 'lg' } : {},
              style: isContact ? { backgroundColor: rawColorValues.cream } : {},
              TxtProps: { variant: isCareers ? 'h6' : undefined },
            }}
          />
        ),
        body: [
          isCareers && (
            <JobPositions key="jobPositions" {...{ items: entry.jobPositionMultiple }} />
          ),
          isContact && (
            <BlockHeader
              key="blockHeader"
              maxWidth="none"
              cx={{ mB: 'xl' }}
              HeadingProps={{ variant: 'h5' }}
              heading={entry.heading}
              content={entry.label}
            />
          ),
          isContact && <Formie key="form" form={entry.form ?? undefined} />,
        ],
        footer,
      }}
    />
  );
};

export default GridLayout;
